import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { AppShell } from "@/components/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Affiliates from "@/pages/Affiliates";
import AffiliateDetail from "@/pages/AffiliateDetail";
import Onboarding from "@/pages/Onboarding";
import Orders from "@/pages/Orders";
import Codes from "@/pages/Codes";
import Campaigns from "@/pages/Campaigns";
import Payouts from "@/pages/Payouts";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";
import Analytics from "@/pages/Analytics";
import Communications from "@/pages/Communications";
import WeeklyTasksPage from "@/pages/WeeklyTasksPage";
import AffiliateLogin from "@/pages/AffiliateLogin";
import PortalShell from "@/pages/portal/PortalShell";
import PortalDashboardPage from "@/pages/portal/PortalDashboardPage";
import PortalOrdersPage from "@/pages/portal/PortalOrdersPage";
import PortalReferralsPage from "@/pages/portal/PortalReferralsPage";
import PortalPayoutsPage from "@/pages/portal/PortalPayoutsPage";
import PortalSharePage from "@/pages/portal/PortalSharePage";
import PortalSettingsPage from "@/pages/portal/PortalSettingsPage";
import { Toaster } from "sonner";
import "@/App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      {/* Affiliate self-serve portal — separate auth, no CRM shell */}
      <Route path="/affiliate/login" element={<AffiliateLogin />} />
      <Route path="/affiliate" element={<PortalShell />}>
        <Route index element={<PortalDashboardPage />} />
        <Route path="orders" element={<PortalOrdersPage />} />
        <Route path="referrals" element={<PortalReferralsPage />} />
        <Route path="payouts" element={<PortalPayoutsPage />} />
        <Route path="share" element={<PortalSharePage />} />
        <Route path="ai" element={<Navigate to="/affiliate" replace />} />
        <Route path="settings" element={<PortalSettingsPage />} />
      </Route>
      <Route element={<Protected><AppShell /></Protected>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/affiliates" element={<Affiliates />} />
        <Route path="/affiliates/:id" element={<AffiliateDetail />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/codes" element={<Codes />} />
        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/payouts" element={<Payouts />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/communications" element={<Communications />} />
        <Route path="/weekly-tasks" element={<WeeklyTasksPage />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </div>
  );
}
